var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { Link, useHistory } from "react-router-dom";
import ContentLayout from "../../../Layout/ContentLayout";
import usePagedSortedTable, { TotalPageMappers, } from "../../../Hooks/usePagedSortedTable";
import BooleanDisplay from "../../../UI/BooleanDisplay/BooleanDisplay";
import ServiceDeliveryLocationService from "../../../../Services/ServiceDeliveryLocation.service";
import { getServiceDeliveryLocationCreateRoute, getServiceDeliveryLocationDetailPath, } from "./AdminServiceDeliveryLocationRoutes";
import { InlineFormFormat } from "../../../UI/FormFormat/FormFormat";
import SecondaryNavButton from "../../../UI/SecondaryNav/SecondaryNavButton";
import SecondaryNavLayout from "../../../Layout/SecondaryNavLayout";
import DateService from "../../../../Services/Shared/Date.service";
import useCheckboxes from "../../../Hooks/useCheckboxes";
import useService from "../../../Hooks/useService";
import SelectField from "../../../Form/SelectField";
const PAGE_SIZE = 100;
const tableSearchFormStateToSearchArgs = (formState) => {
    var _a, _b, _c;
    let active;
    switch ((_a = formState.active) === null || _a === void 0 ? void 0 : _a.value) {
        case "active":
            active = true;
            break;
        case "inactive":
            active = false;
            break;
        default:
            active = undefined;
    }
    let showInLegacyScheduler;
    switch ((_b = formState.showInLegacyScheduler) === null || _b === void 0 ? void 0 : _b.value) {
        case "visible":
            showInLegacyScheduler = true;
            break;
        case "hidden":
            showInLegacyScheduler = false;
            break;
        default:
            showInLegacyScheduler = undefined;
    }
    let showInNewScheduler;
    switch ((_c = formState.showInNewScheduler) === null || _c === void 0 ? void 0 : _c.value) {
        case "visible":
            showInNewScheduler = true;
            break;
        case "hidden":
            showInNewScheduler = false;
            break;
        default:
            showInNewScheduler = undefined;
    }
    return {
        active,
        showInLegacyScheduler,
        showInNewScheduler,
    };
};
const ServiceDeliveryLocationIndex = () => {
    var _a, _b;
    const history = useHistory();
    const [searchArgs, setSearchArgs] = React.useState({
        showInLegacyScheduler: undefined,
        showInNewScheduler: undefined,
        active: undefined,
    });
    const { getCheckbox, checkedItems, unCheckEverything } = useCheckboxes({
        externallyCheckedItems: [],
        equalsFunc: (a, b) => a.id === b.id,
    });
    const { table, dataState, refresh } = usePagedSortedTable({
        striped: true,
        hover: true,
        noDataComponent: "No offices found",
        rowVerticalPadding: 2,
        searchArgs,
        getData: (sort, pageNumber, sArgs) => {
            return ServiceDeliveryLocationService.search({
                active: sArgs.active,
                showInLegacyScheduler: sArgs.showInLegacyScheduler,
                showInNewScheduler: sArgs.showInNewScheduler,
            }, {
                max: PAGE_SIZE,
                offset: pageNumber * PAGE_SIZE,
                sort: sort === null || sort === void 0 ? void 0 : sort.sort,
                order: sort === null || sort === void 0 ? void 0 : sort.order,
            });
        },
        initialSort: { sort: "SERVICE_DELIVERY_LOCATION_NAME", order: "asc" },
        getNumPages: (result) => TotalPageMappers.EngagePagedResult(result, PAGE_SIZE),
        addCheckboxes: {
            useCheckboxesMakeCheckbox: getCheckbox,
            getCheckedItem: (data, index) => data.data[index],
        },
        columns: [
            {
                title: "Id",
                sortId: "SERVICE_DELIVERY_LOCATION_ID",
                size: 0.2,
            },
            {
                title: "Name",
                sortId: "SERVICE_DELIVERY_LOCATION_NAME",
                size: 2,
            },
            {
                title: "Campus",
                sortId: "SERVICE_DELIVERY_LOCATION_LOCATION",
                size: 0.8,
            },
            {
                title: "Active",
                sortId: "SERVICE_DELIVERY_LOCATION_ACTIVE",
                size: 0.4,
            },
            {
                title: "Modified By",
                sortId: "SERVICE_DELIVERY_LOCATION_MODIFIED_BY_PERSON",
                size: 0.5,
            },
            {
                title: "Modified Date",
                sortId: "SERVICE_DELIVERY_LOCATION_MODIFIED_DATE",
                size: 0.5,
            },
            {
                title: "Visible in Legacy Scheduler",
                sortId: "SERVICE_DELIVERY_LOCATION_SHOW_IN_LEGACY_SCHEDULER",
                size: 0.5,
            },
            {
                title: "Visible in New Scheduler",
                sortId: "SERVICE_DELIVERY_LOCATION_SHOW_IN_NEW_SCHEDULER",
                size: 0.5,
            },
        ],
        rows: ({ data }) => data.map((serviceDeliveryLocation, index) => {
            return [
                serviceDeliveryLocation.id,
                _jsx(Link, { to: getServiceDeliveryLocationDetailPath(serviceDeliveryLocation.id.toString()), children: serviceDeliveryLocation.name }, index),
                _jsx(Link, { 
                    // We currently don't have a route method to locations since it is a GSP view, so we put it together here for now
                    // We also have to use _target blank because react-router's link doesn't work from React to GSP
                    to: "/aviso/location/show/" +
                        serviceDeliveryLocation.location.id.toString(), target: "_blank", children: serviceDeliveryLocation.location.name }, index),
                _jsx(BooleanDisplay, { val: serviceDeliveryLocation.active }, index),
                serviceDeliveryLocation.modifiedBy.fullName,
                DateService.displayWithTime(new Date(serviceDeliveryLocation.modifiedDate)),
                _jsx(BooleanDisplay, { val: serviceDeliveryLocation.showInLegacyScheduler }, index),
                _jsx(BooleanDisplay, { val: serviceDeliveryLocation.showInNewScheduler }, index),
            ];
        }),
    });
    const [bulkToggleActivationState, bulkToggleActivation] = useService(ServiceDeliveryLocationService.bulkToggleActivation);
    const [bulkToggleSchedulerVisibilityState, bulkToggleSchedulerVisibility] = useService(ServiceDeliveryLocationService.bulkToggleSchedulerVisibility);
    const isNavbarButtonDisabled = !checkedItems.length ||
        bulkToggleActivationState.isLoading ||
        bulkToggleSchedulerVisibilityState.isLoading ||
        dataState.isLoading;
    return (_jsx(SecondaryNavLayout, { nav: _jsxs(_Fragment, { children: [_jsx(SecondaryNavButton, { icon: "plus", label: "Create", title: "Create new office", onClick: () => history.push(getServiceDeliveryLocationCreateRoute()) }), _jsx(SecondaryNavButton, { icon: "check", label: "Activate", title: "Activate selected offices", onClick: () => bulkToggleActivation({
                        ids: checkedItems.map((sdl) => sdl.id),
                        active: true,
                    }).then(() => {
                        refresh();
                        unCheckEverything();
                    }), confirmMessage: `This will activate the current ${checkedItems.length} selected ${checkedItems.length > 1 ? `offices` : `office`}. Are you sure?`, disabled: isNavbarButtonDisabled }), _jsx(SecondaryNavButton, { icon: "ban", label: "Deactivate", title: "Deactivate selected offices", onClick: () => bulkToggleActivation({
                        ids: checkedItems.map((sdl) => sdl.id),
                        active: false,
                    }).then(() => {
                        refresh();
                        unCheckEverything();
                    }), confirmMessage: `This will deactivate the current ${checkedItems.length} selected ${checkedItems.length > 1 ? `offices` : `office`}. Are you sure?`, disabled: isNavbarButtonDisabled }), _jsx("div", { className: "h-100", style: {
                        borderRight: "1px solid",
                        opacity: "0.25",
                    } }), _jsx(SecondaryNavButton, { icon: "check", label: "Show In Legacy Scheduler", title: "Show In Legacy Scheduler", confirmMessage: `This will display the current ${checkedItems.length} selected ${checkedItems.length > 1 ? `offices` : `office`} in the Legacy Scheduler. Are you sure?`, onClick: () => bulkToggleSchedulerVisibility({
                        ids: checkedItems.map((sdl) => sdl.id),
                        isNewScheduler: false,
                        isVisible: true,
                    }).then(() => {
                        refresh();
                        unCheckEverything();
                    }), disabled: isNavbarButtonDisabled }), _jsx(SecondaryNavButton, { icon: "ban", label: "Hide In Legacy Scheduler", title: "Hide In Legacy Scheduler", confirmMessage: `This will hide the current ${checkedItems.length} selected ${checkedItems.length > 1 ? `offices` : `office`} in the Legacy Scheduler. Are you sure?`, onClick: () => bulkToggleSchedulerVisibility({
                        ids: checkedItems.map((sdl) => sdl.id),
                        isNewScheduler: false,
                        isVisible: false,
                    }).then(() => {
                        refresh();
                        unCheckEverything();
                    }), disabled: isNavbarButtonDisabled }), _jsx("div", { className: "h-100", style: {
                        borderRight: "1px solid",
                        opacity: "0.25",
                    } }), _jsx(SecondaryNavButton, { icon: "check", label: "Show In New Scheduler", title: "Show In New Scheduler", confirmMessage: `This will display the current ${checkedItems.length} selected ${checkedItems.length > 1 ? `offices` : `office`} in the New Scheduler. Are you sure?`, onClick: () => bulkToggleSchedulerVisibility({
                        ids: checkedItems.map((sdl) => sdl.id),
                        isNewScheduler: true,
                        isVisible: true,
                    }).then(() => {
                        refresh();
                        unCheckEverything();
                    }), disabled: isNavbarButtonDisabled }), _jsx(SecondaryNavButton, { icon: "ban", label: "Hide In New Scheduler", title: "Hide In New Scheduler", confirmMessage: `This will hide the current ${checkedItems.length} selected ${checkedItems.length > 1 ? `offices` : `office`} in the New Scheduler. Are you sure?`, onClick: () => bulkToggleSchedulerVisibility({
                        ids: checkedItems.map((sdl) => sdl.id),
                        isNewScheduler: true,
                        isVisible: false,
                    }).then(() => {
                        refresh();
                        unCheckEverything();
                    }), disabled: isNavbarButtonDisabled })] }), dontAddSpacer: true, children: _jsxs(ContentLayout, { whiteBackground: true, paddingTop: true, paddingBottom: true, className: "fullMinHeightMinusPrimaryNav", children: [_jsxs("h1", { className: "mb-3", children: ["Offices ", ((_a = dataState.data) === null || _a === void 0 ? void 0 : _a.total) ? `(${(_b = dataState.data) === null || _b === void 0 ? void 0 : _b.total})` : ""] }), _jsx("div", { className: "mb-3", children: _jsxs(InlineFormFormat, { saveButtonContents: "Search", handleSubmit: (formState) => __awaiter(void 0, void 0, void 0, function* () {
                            setSearchArgs(tableSearchFormStateToSearchArgs(formState));
                        }), children: [_jsx(SelectField, { label: "Status", name: "active", options: [
                                    {
                                        label: "Active",
                                        value: "active",
                                    },
                                    {
                                        label: "Inactive",
                                        value: "inactive",
                                    },
                                ] }), _jsx(SelectField, { label: "Legacy Scheduler Visiblity", name: "showInLegacyScheduler", options: [
                                    {
                                        label: "Visible in Legacy Scheduler",
                                        value: "visible",
                                    },
                                    {
                                        label: "Hidden in Legacy Scheduler",
                                        value: "hidden",
                                    },
                                ] }), _jsx(SelectField, { label: "New Scheduler Visiblity", name: "showInNewScheduler", options: [
                                    {
                                        label: "Visible in New Scheduler",
                                        value: "visible",
                                    },
                                    {
                                        label: "Hidden in New Scheduler",
                                        value: "hidden",
                                    },
                                ] })] }) }), _jsx("div", { className: "py-2", children: table })] }) }));
};
export default ServiceDeliveryLocationIndex;
